import React, { useState, useEffect } from 'react';

import { UiDialog as Dialog } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from './actions';
import ListItems from './components/ListItems';
import * as selectors from './selectors';

const Container = ({
    closeModal,
    fetchBrands,
    fetchPanelsIds,
    filterItems,
    handleAddPanel,
    handleAfterSave,
    isFetchingItems,
    isInitializing,
    isOpenModal,
    items,
    paginationItems,
    panelsIdsData,
    productBrands,
}) => {
    const { t } = useTranslation();
    const [filterData, setFilterData] = useState({
        brandName: '',
        maxPower: '',
        orderBy: 'created_at',
        page: 0,
        pageSize: 25,
        searchText: '',
        sortBy: 'desc',
    });

    useEffect(() => {
        filterItems(filterData);
        fetchBrands();
        fetchPanelsIds();
    }, []);

    return (
        <Dialog
            onClose={() => closeModal()}
            open={isOpenModal}
            size="lg"
            title={`${t('Add')} ${t('Panel', { count: 2 }).toLowerCase()}`}
        >
            <ListItems
                filterData={filterData}
                filterItems={filterItems}
                handleClickAdd={(item) =>
                    handleAddPanel(filterData, item, handleAfterSave)
                }
                isFetching={isInitializing || isFetchingItems}
                items={items}
                paginationData={paginationItems}
                panelsIdsData={panelsIdsData}
                setFilterData={setFilterData}
                productBrands={productBrands}
            />
        </Dialog>
    );
};

Container.propTypes = {
    closeModal: PropTypes.func,
    fetchBrands: PropTypes.func,
    fetchPanelsIds: PropTypes.func,
    filterItems: PropTypes.func,
    handleAddPanel: PropTypes.func,
    handleAfterSave: PropTypes.func,
    isFetchingItems: PropTypes.bool,
    isInitializing: PropTypes.bool,
    isOpenModal: PropTypes.bool,
    items: PropTypes.array,
    paginationItems: PropTypes.object,
    panelsIdsData: PropTypes.array,
    productBrands: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    isFetchingItems: selectors.getIsFetchingItems,
    isOpenModal: selectors.getIsOpenModal,
    items: selectors.getFetchItemsData,
    paginationItems: selectors.getFetchItemsPagination,
    panelsIdsData: selectors.getPanelsIdsData,
    productBrands: selectors.getBrandsData,
});

const mapDispatchToProps = (dispatch) => ({
    closeModal: (filterData) => dispatch(actions.closeModal(filterData)),
    fetchBrands: () => dispatch(actions.fetchBrands()),
    fetchPanelsIds: () => dispatch(actions.fetchPanelsIds()),
    filterItems: (filterData) => dispatch(actions.filterItems(filterData)),
    handleAddPanel: (filterData, panelId, callback) =>
        dispatch(actions.addPanel(filterData, panelId, callback)),
    handleClickDelete: (filterData, panelId, panelName) =>
        dispatch(actions.prepareDelete(filterData, panelId, panelName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
